import ChatbotPopup from "components/chatbot/ChatbotPopup";
import { ChatbotButton } from "components/chatbot/chatbotButton/ChatbotButton";
import DialogContainer from "components/dialog/controller/DialogContainer";
import Loading from "components/loading/Loading";
import { Alert } from "components/modal/Alert";
import { Confirm } from "components/modal/Confirm";
import { Toast } from "components/toast/Toast";
import { ListMoreMenu } from "components/tooltip/ListMoreMenu/ListMoreMenu";
import { FEATURES } from "consts/feature/const";
import { useAuth } from "hooks/Auth/useAuth";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import useChatbotStore from "stores/chatbot/useChatbotStore";
import useAlertStore from "stores/useAlertStore";
import useLoadingStore from "stores/useLoadingStore";
import useMoreMenuStore from "stores/useMoreMenuStore";
import useResizeGuideStore from "stores/useResizeGuideStore";

export const Overlays = () => {
  const { isLoggedIn } = useAuth();
  const { isAlert, isConfirm } = useAlertStore();
  const { isMoreMenuVisible } = useMoreMenuStore();
  const { loadingCount } = useLoadingStore();
  const { hideChatbot } = useChatbotStore();
  const { resizeGuideLineVisible, lineDirection, lineX, lineY } =
    useResizeGuideStore();
  const { completeLoadingState } = useLoadingStore();

  return (
    <>
      {/* 로딩창 */}
      {(completeLoadingState || loadingCount > 0) && <Loading />}

      {/* 리스트 more 메뉴 */}
      {isMoreMenuVisible && <ListMoreMenu />}

      {/* 요소 사이즈 조절시 표출되는 가이드라인 */}
      {resizeGuideLineVisible && (
        <span
          id="resize-guide-line"
          style={
            lineDirection === "horizon"
              ? {
                  top: lineY,
                  left: 0,
                  width: "100%",
                  height: 0,
                  borderBottom: "0.3rem dashed orange",
                }
              : {
                  top: 0,
                  left: lineX,
                  width: 0,
                  height: "100%",
                  borderRight: "0.3rem dashed orange",
                }
          }
        />
      )}

      <DialogContainer />

      {FEATURES.CHATBOT_VIEW && (
        <>
          <ChatbotPopup />
          {isLoggedIn && !hideChatbot && <ChatbotButton />}
        </>
      )}

      {/* 메시지창 */}
      <TransitionGroup>
        <Toast />
      </TransitionGroup>

      {/* 알림창 */}
      <CSSTransition
        in={isAlert}
        timeout={500}
        classNames="modal"
        unmountOnExit
      >
        <Alert />
      </CSSTransition>

      {/* 알림창 */}
      <CSSTransition
        in={isConfirm}
        timeout={500}
        classNames="modal"
        unmountOnExit
      >
        <Confirm />
      </CSSTransition>
    </>
  );
};
